import {useEffect, useState} from "react";
import changelog from "../../data/changelog.md";
import MarkDownDialog from "./MarkDownDialog";

interface IChangeLog {
    onClose: () => void
    open: boolean
}
export default function ChangeLog({onClose, open}: IChangeLog) {
    const [markdown, setMarkdown] = useState("");

    useEffect(() => {
        if (markdown === "") {
            fetch(changelog).then(response => response.text()).then(text => {
                setMarkdown(text);
            });
        }
    }, [markdown]);
    return (
        <MarkDownDialog markdown={markdown} onClose={onClose} open={open}/>
    );
}